
import "@layouts/style.css";

import "@layouts/tailwind.css";

import "@layouts/satoshi.css";

import "@layouts/cardGradients.css";

import type React from "react";
import { ModalProvider } from "@context/ModalContext";
import { AuthProvider } from "@context/AuthContext";
import { AlertProvider } from "@context/AlertContext";
import AlertToast from "@components/AlertToast";
import { SearchProvider } from "@context/SearchContext";
import { ResultProvider } from "@context/ResultContext";
import { GuidedSearchProvider } from "@context/GuidedSearchContext";
import { useEffect } from "react";
import { initPosthogClient, posthog } from "@service/posthogClient";
import { SearchCountProvider } from "@context/SearchCountContext";
import { usePageContext } from "vike-react/usePageContext";
import ManualFeedback from "@components/Feedback/ManualFeedback";
import { initSessionTracker } from "@service/sessionTracker";

export default function LayoutDefault({
    children,
}: { children: React.ReactNode }) {
    useEffect(() => {
        initPosthogClient();
        posthog.capture("app_loaded");

        // Initialize session tracking
        initSessionTracker();
    }, []);
    return (
        <div className="h-full w-full m-0 flex flex-col relative items-center">
            <AlertProvider>
                <AuthProvider>
                    <GuidedSearchProvider>
                        <ModalProvider>
                            <ResultProvider>
                                <SearchProvider>
                                    <SearchCountProvider>
                                        {children}
                                    </SearchCountProvider>
                                </SearchProvider>
                            </ResultProvider>
                        </ModalProvider>
                    </GuidedSearchProvider>
                </AuthProvider>
                <AlertToast classname="slide"></AlertToast>
            </AlertProvider>
        </div>
    );
}
